import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { AuthService } from "../service/auth.service";

@Component({
  selector: "app-reserve-public",
  templateUrl: "./reserve-public.component.html",
  styles: [],
  standalone: false,
})
export class ReservePublicComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message
  ) { }

  id = ''
  dataStepper = [
    {
      status: "working",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Scegli il giorno",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Scegli il servizio",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Scegli l'operatore",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Scegli l'orario",
    },
    {
      status: "incomplete",
      customLabel: "text-medium mt-2 font-semibold w-[100px] !ml-0",
      label: "Inserisci i tuoi dati",
    }
  ];
  minDate = new Date()
  dayReserve = new Date()
  date: any
  dateToShow = ''
  timeReserve = ''
  showStepper = true
  window = window
  myOperators: any[] = []
  myProducts: any[] = []
  mySalon: any = null
  operator: any = null
  service: any = null
  slots: any[] = []
  slotsToVisualize :any[]= []
  selectedSlot: any = null
  myBooking = {
    salonId: -1,
    itemId: -1,
    startDate: new Date(),
    endDate: new Date(),
    operatorId: -1,
    user: {
      email: '',
      firstName: '',
      lastName: '',
      phone: ''
    }
  }
  api = api
  categories: any[] = []
  currentCategory = -1
  currentService = -1
  baseUrl = api.baseUrl
  currentStep = 0
  currentOperator = -1
  today = new Date(new Date(new Date().setHours(0)).setMinutes(0))
  mobileDetailsExpanded = false
  daysToDisable :number[]= []
  weekCalendar :any[]= [{}, {}, {}, {}, {}, {}, {}]
  dateWeekMobile = new Date()
  dateWeekMobileToShow = ''
  indexDayMobile = -1
  startingTouchY = -1
  touchingBump = false
  containerH = 120


  ngOnInit(): void {
    this.id = window.location.pathname.split('/')[2]
    this.getMyProducts()
  }

  startTouch(event: any) {
    if (event.touches[0]) {
      this.startingTouchY = event.touches[0].clientY
      this.touchingBump = true
      if (this.mobileDetailsExpanded) {
        this.containerH = window.innerHeight - 25
      } else {
        this.containerH = 120
      }
    }
  }

  touchMove(event: any) {
    if (this.touchingBump && event.touches[0]) {
      if (this.mobileDetailsExpanded) { 
        let diff = this.startingTouchY - event.touches[0].clientY
        if (diff <= 0) {
          this.containerH = (window.innerHeight - 25) + diff
        } else {
          this.containerH = (window.innerHeight - 25)
        }
      } else {
        let diff = this.startingTouchY - event.touches[0].clientY
        if (diff >= 0) {
          this.containerH = 120 + diff
        } else {
          this.containerH = 120
        }
      }
    }
  }

  touchEnd() {
    this.touchingBump = false
    if (this.containerH > 250) {
      this.mobileDetailsExpanded = true
      this.containerH = (window.innerHeight - 25)
    } else {
      this.mobileDetailsExpanded = false
      this.containerH = 120
    }
    console.log(this.containerH);
    
  }

  changeWeek(offset :number= 0,t:any){
  let current = new Date(this.dateWeekMobile);
  current.setDate(current.getDate() + offset * 7);
  let day = current.getDay();
  let diffToMonday = (day === 0 ? -6 : 1 - day);
  let firstDay = new Date(current);
  firstDay.setDate(current.getDate() + diffToMonday);
  this.dateWeekMobile = new Date(firstDay)
  let lastDay = new Date(firstDay);
  lastDay.setDate(firstDay.getDate() + 6);
  this.dateWeekMobileToShow = `${t('months.'+firstDay.getMonth())} ${firstDay.getDate()} - ${t('months.'+lastDay.getMonth())} ${lastDay.getDate()}`
  this.loader.on()
  this.slots = []
  this.rest.get(`/app/booking/by_operators/${this.mySalon.id}/${this.myOperators[this.currentOperator].id}?itemId=${this.service.id}&start=${firstDay.getFullYear()}-${firstDay.getMonth() + 1}-${firstDay.getDate()}&end=${lastDay.getFullYear()}-${lastDay.getMonth() + 1}-${lastDay.getDate()}`).subscribe({
      next: (value: any) => {
        this.loader.off(true);
       this.slots = value.map((slot:any)=>{
        slot.day = new Date(slot.date).getDay()
        slot.month = new Date(slot.date).getMonth()
        slot.dayMonth = new Date(slot.date).getDate(),
        slot.year = new Date(slot.date).getFullYear()
        return slot
       })
      },
      error: (value) => {
        this.loader.off(true);
      },
    })
  }

  changeMonth(event: any) {
    this.dateToShow = ''
    this.slotsToVisualize = []
    this.getSuggestedSlots(event)
  }

  getCategories() {
    this.loader.on()
    this.rest.get(`/app/service/categories/${this.mySalon.companyId}`).subscribe({
      next: (value: any) => {
        let newValue = value.map((res: any) => {
          res.items.map((item: any) => {
            item.formattedDuration = Math.floor(item.duration / 60) + 'h ' + (item.duration % 60) + 'm'
            return item
          })
          return res
        })
        this.categories = newValue
        this.loader.off(true);
      },
      error: (value) => {
        this.loader.off(true);
      },
    })
  }

  getMyProducts() {
    this.loader.on()
    this.rest.get(`/app/salon/s/${this.id}`).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.myProducts = value.services
        this.mySalon = value.salon
        this.getCategories();
      },
      error: (value) => {
        this.loader.off(true);
        this.currentStep = -1
        this.message.showMessage('Il link non corrisponde a nessun salone', 'error')
      },
    })
  }

  getSuggestedSlots(myDate:any) {
    this.loader.on()
    let date = {
        day:new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate(),
        month:new Date().getMonth(),
        date:new Date(),
        year:new Date().getFullYear()
      }
    if(myDate){
      date = myDate
    }

    this.rest.get(`/app/booking/by_operators/${this.mySalon.id}/${this.myOperators[this.currentOperator].id}?itemId=${this.service.id}&start=${date.year}-${date.month + 1}-${1}&end=${date.year}-${date.month + 1}-${date.day}`).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.daysToDisable = []
        for (let index = 0; index < date.day; index++) {
          let day = index + 1
          let dateFormat = date.year + '-' + (date.month + 1) + '-' + (day >= 10 ? day : '0' + day)
          let mySlotsDay = value.find((slotDay:any)=>{
            return dateFormat == slotDay.date
          })
          if(!mySlotsDay || !(mySlotsDay?.slots?.length > 0)){
            this.daysToDisable.push(day)
          }
          
          
        }
       this.slots = value
      },
      error: (value) => {
        this.loader.off(true);
      },
    })
  }

  createBooking() {
    const [h, m] = this.selectedSlot.split(":");
    this.myBooking.salonId = this.mySalon.id
    this.myBooking.itemId = this.service.id
    this.myBooking.operatorId = this.operator.id
    this.myBooking.startDate = new Date(new Date(new Date(this.date.year + '-' + (this.date.month + 1) + '-' + this.date.day).setHours(h)).setMinutes(m))
    let newM = parseInt(m) + this.service.duration
    let newH = parseInt(h) + Math.floor(newM / 60)
    newM = Math.floor(newM / 60) >= 1 ? (newM - (Math.floor(newM / 60) * 60)) : newM
    this.myBooking.endDate = new Date(new Date(new Date(this.date.year + '-' + (this.date.month + 1) + '-' + this.date.day).setHours(newH)).setMinutes(newM))
    this.loader.on()
    this.rest.post('/app/book', this.myBooking).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.message.showMessage('Prenotazione avvenuta con successo', 'success')
      },
      error: (value) => {
        this.loader.off(true);
        this.message.showMessage('Errore nella creazione della prenotazione', 'error')
      },
    })
  }

  getMyOperators() {
    this.loader.on();
    this.rest.get(`/app/item/${this.service.id}/operators`).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.myOperators = value.map((res: any) => {
          res.fullName = res.firstName + " " + res.lastName;
          return res;
        });
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  changeDate(date: any) {
    this.date = date
    this.dateToShow = date.formattedDate
    let dateFormat = date.year + '-' + (date.month + 1) + '-' + (date.day >= 10 ? date.day : '0' + date.day)
    this.slotsToVisualize = this.slots.find((slot:any)=> slot.date == dateFormat).slots
  }

  nextStep(index: number) {
    if (this.dataStepper[index].status == 'working') {
      this.dataStepper[index].status = 'success'
      if (this.dataStepper[index + 1]) {
        this.dataStepper[index + 1].status = 'working'
      }

    }
    this.showStepper = false
    setTimeout(() => {
      this.showStepper = true
    }, 0);
  }

  formatDate(d: Date) {
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  getCompleteData(dateReserve: Date) {
    const date = dateReserve;
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedDate = `${day}/${month}/${year} - ${hours}:${minutes < 10 ? "0" : ""
      }${minutes}`;
    return formattedDate
  }
}
